// Static country + calling-code list, bundled instead of fetched from
// restcountries.com at runtime — that API is unreliable (CORS failures,
// downtime) and a failed fetch left the phone-country dropdown in
// ContactInfoModal.js effectively empty with only a silent console error.
// cca2 is the ISO 3166-1 alpha-2 code (used to derive the flag emoji).
export const COUNTRY_DIAL_CODES = [
  { name: 'Afghanistan', cca2: 'AF', dialCode: '+93' },
  { name: 'Albania', cca2: 'AL', dialCode: '+355' },
  { name: 'Algeria', cca2: 'DZ', dialCode: '+213' },
  { name: 'Angola', cca2: 'AO', dialCode: '+244' },
  { name: 'Argentina', cca2: 'AR', dialCode: '+54' },
  { name: 'Armenia', cca2: 'AM', dialCode: '+374' },
  { name: 'Australia', cca2: 'AU', dialCode: '+61' },
  { name: 'Austria', cca2: 'AT', dialCode: '+43' },
  { name: 'Azerbaijan', cca2: 'AZ', dialCode: '+994' },
  { name: 'Bahrain', cca2: 'BH', dialCode: '+973' },
  { name: 'Bangladesh', cca2: 'BD', dialCode: '+880' },
  { name: 'Belarus', cca2: 'BY', dialCode: '+375' },
  { name: 'Belgium', cca2: 'BE', dialCode: '+32' },
  { name: 'Benin', cca2: 'BJ', dialCode: '+229' },
  { name: 'Botswana', cca2: 'BW', dialCode: '+267' },
  { name: 'Brazil', cca2: 'BR', dialCode: '+55' },
  { name: 'Bulgaria', cca2: 'BG', dialCode: '+359' },
  { name: 'Burkina Faso', cca2: 'BF', dialCode: '+226' },
  { name: 'Burundi', cca2: 'BI', dialCode: '+257' },
  { name: 'Cameroon', cca2: 'CM', dialCode: '+237' },
  { name: 'Canada', cca2: 'CA', dialCode: '+1' },
  { name: 'Chad', cca2: 'TD', dialCode: '+235' },
  { name: 'Chile', cca2: 'CL', dialCode: '+56' },
  { name: 'China', cca2: 'CN', dialCode: '+86' },
  { name: 'Colombia', cca2: 'CO', dialCode: '+57' },
  { name: 'Congo (DRC)', cca2: 'CD', dialCode: '+243' },
  { name: 'Croatia', cca2: 'HR', dialCode: '+385' },
  { name: 'Cyprus', cca2: 'CY', dialCode: '+357' },
  { name: 'Czechia', cca2: 'CZ', dialCode: '+420' },
  { name: 'Denmark', cca2: 'DK', dialCode: '+45' },
  { name: 'Egypt', cca2: 'EG', dialCode: '+20' },
  { name: 'Eswatini', cca2: 'SZ', dialCode: '+268' },
  { name: 'Ethiopia', cca2: 'ET', dialCode: '+251' },
  { name: 'Finland', cca2: 'FI', dialCode: '+358' },
  { name: 'France', cca2: 'FR', dialCode: '+33' },
  { name: 'Gabon', cca2: 'GA', dialCode: '+241' },
  { name: 'Gambia', cca2: 'GM', dialCode: '+220' },
  { name: 'Georgia', cca2: 'GE', dialCode: '+995' },
  { name: 'Germany', cca2: 'DE', dialCode: '+49' },
  { name: 'Ghana', cca2: 'GH', dialCode: '+233' },
  { name: 'Greece', cca2: 'GR', dialCode: '+30' },
  { name: 'Guinea', cca2: 'GN', dialCode: '+224' },
  { name: 'Hungary', cca2: 'HU', dialCode: '+36' },
  { name: 'India', cca2: 'IN', dialCode: '+91' },
  { name: 'Indonesia', cca2: 'ID', dialCode: '+62' },
  { name: 'Iran', cca2: 'IR', dialCode: '+98' },
  { name: 'Iraq', cca2: 'IQ', dialCode: '+964' },
  { name: 'Ireland', cca2: 'IE', dialCode: '+353' },
  { name: 'Italy', cca2: 'IT', dialCode: '+39' },
  { name: 'Ivory Coast', cca2: 'CI', dialCode: '+225' },
  { name: 'Jamaica', cca2: 'JM', dialCode: '+1876' },
  { name: 'Japan', cca2: 'JP', dialCode: '+81' },
  { name: 'Jordan', cca2: 'JO', dialCode: '+962' },
  { name: 'Kazakhstan', cca2: 'KZ', dialCode: '+7' },
  { name: 'Kenya', cca2: 'KE', dialCode: '+254' },
  { name: 'Kuwait', cca2: 'KW', dialCode: '+965' },
  { name: 'Kyrgyzstan', cca2: 'KG', dialCode: '+996' },
  { name: 'Lebanon', cca2: 'LB', dialCode: '+961' },
  { name: 'Lesotho', cca2: 'LS', dialCode: '+266' },
  { name: 'Liberia', cca2: 'LR', dialCode: '+231' },
  { name: 'Libya', cca2: 'LY', dialCode: '+218' },
  { name: 'Madagascar', cca2: 'MG', dialCode: '+261' },
  { name: 'Malawi', cca2: 'MW', dialCode: '+265' },
  { name: 'Malaysia', cca2: 'MY', dialCode: '+60' },
  { name: 'Mali', cca2: 'ML', dialCode: '+223' },
  { name: 'Mexico', cca2: 'MX', dialCode: '+52' },
  { name: 'Morocco', cca2: 'MA', dialCode: '+212' },
  { name: 'Mozambique', cca2: 'MZ', dialCode: '+258' },
  { name: 'Namibia', cca2: 'NA', dialCode: '+264' },
  { name: 'Nepal', cca2: 'NP', dialCode: '+977' },
  { name: 'Netherlands', cca2: 'NL', dialCode: '+31' },
  { name: 'New Zealand', cca2: 'NZ', dialCode: '+64' },
  { name: 'Niger', cca2: 'NE', dialCode: '+227' },
  { name: 'Nigeria', cca2: 'NG', dialCode: '+234' },
  { name: 'North Macedonia', cca2: 'MK', dialCode: '+389' },
  { name: 'Norway', cca2: 'NO', dialCode: '+47' },
  { name: 'Oman', cca2: 'OM', dialCode: '+968' },
  { name: 'Pakistan', cca2: 'PK', dialCode: '+92' },
  { name: 'Philippines', cca2: 'PH', dialCode: '+63' },
  { name: 'Poland', cca2: 'PL', dialCode: '+48' },
  { name: 'Portugal', cca2: 'PT', dialCode: '+351' },
  { name: 'Qatar', cca2: 'QA', dialCode: '+974' },
  { name: 'Romania', cca2: 'RO', dialCode: '+40' },
  { name: 'Russia', cca2: 'RU', dialCode: '+7' },
  { name: 'Rwanda', cca2: 'RW', dialCode: '+250' },
  { name: 'Saudi Arabia', cca2: 'SA', dialCode: '+966' },
  { name: 'Senegal', cca2: 'SN', dialCode: '+221' },
  { name: 'Serbia', cca2: 'RS', dialCode: '+381' },
  { name: 'Sierra Leone', cca2: 'SL', dialCode: '+232' },
  { name: 'Singapore', cca2: 'SG', dialCode: '+65' },
  { name: 'Slovakia', cca2: 'SK', dialCode: '+421' },
  { name: 'Somalia', cca2: 'SO', dialCode: '+252' },
  { name: 'South Africa', cca2: 'ZA', dialCode: '+27' },
  { name: 'South Korea', cca2: 'KR', dialCode: '+82' },
  { name: 'South Sudan', cca2: 'SS', dialCode: '+211' },
  { name: 'Spain', cca2: 'ES', dialCode: '+34' },
  { name: 'Sri Lanka', cca2: 'LK', dialCode: '+94' },
  { name: 'Sudan', cca2: 'SD', dialCode: '+249' },
  { name: 'Sweden', cca2: 'SE', dialCode: '+46' },
  { name: 'Switzerland', cca2: 'CH', dialCode: '+41' },
  { name: 'Tanzania', cca2: 'TZ', dialCode: '+255' },
  { name: 'Thailand', cca2: 'TH', dialCode: '+66' },
  { name: 'Togo', cca2: 'TG', dialCode: '+228' },
  { name: 'Tunisia', cca2: 'TN', dialCode: '+216' },
  { name: 'Turkey', cca2: 'TR', dialCode: '+90' },
  { name: 'Turkmenistan', cca2: 'TM', dialCode: '+993' },
  { name: 'Uganda', cca2: 'UG', dialCode: '+256' },
  { name: 'Ukraine', cca2: 'UA', dialCode: '+380' },
  { name: 'United Arab Emirates', cca2: 'AE', dialCode: '+971' },
  { name: 'United Kingdom', cca2: 'GB', dialCode: '+44' },
  { name: 'United States', cca2: 'US', dialCode: '+1' },
  { name: 'Uzbekistan', cca2: 'UZ', dialCode: '+998' },
  { name: 'Vietnam', cca2: 'VN', dialCode: '+84' },
  { name: 'Yemen', cca2: 'YE', dialCode: '+967' },
  { name: 'Zambia', cca2: 'ZM', dialCode: '+260' },
  { name: 'Zimbabwe', cca2: 'ZW', dialCode: '+263' },
].sort((a, b) => a.name.localeCompare(b.name));
